import { FieldStates, validators } from "@shopify/react-form-state";
import { SurveyLimits } from "@teams/cards";
import { TeamsSurveyReminder } from "@teams/types";
import moment from "moment";

import { AuthoringFields } from "../../survey/pages/SurveyAuthoring/PollySurveyAuthoringForm";
import { ListValidatorDictionary } from ".";

export const getSurveyTitleValidator =
  (label: string, maxOverride?: number) =>
  (input: string, other: FieldStates<AuthoringFields>): any => {
    if (other.questions.value.length > 1 || other.type.value !== "poll") {
      const max = maxOverride || SurveyLimits.Title.MaxLength;

      return executeValidators(input.trim(), [
        validators.required(`${label} is required`),
        validators.lengthLessThan(max, `${label} must be less than ${max} characters`),
        validators.lengthMoreThan(
          SurveyLimits.Title.MinLength - 1,
          `${label} must be at least ${SurveyLimits.Title.MinLength} characters`
        ),
      ]);
    }
    return null;
  };

export const getSurveyDescriptionValidator = validators.lengthLessThan(
  SurveyLimits.Description.MaxLength,
  `Message to team must be less then ${SurveyLimits.Description.MaxLength} characters`
);

export function getSurveyRemindersValidator(): Partial<
  ListValidatorDictionary<TeamsSurveyReminder, AuthoringFields>
> {
  return {
    duration: (input: string, other: FieldStates<AuthoringFields>) => {
      if (!input) {
        return "Value is required";
      }

      const dur = moment.duration(input);

      if (!dur.isValid() || dur.asMilliseconds() <= 0) {
        return "Invalid value";
      }

      if (other.openDuration.value) {
        const schedDur = moment.duration(other.openDuration.value);
        if (schedDur.asMinutes() <= dur.asMinutes()) {
          return "Reminder would occur on or before the start date";
        }
      }

      if (
        other.reminders.value.filter(
          r => moment.duration(r.duration).asMilliseconds() === dur.asMilliseconds()
        ).length > 1
      ) {
        return "Reminder is a duplicate";
      }
    },
  };
}

export const executeValidators = <T>(
  input: T,
  validatorList: Array<(input: T) => string | void | unknown | undefined>
) => {
  for (let validator of validatorList) {
    const error = validator(input);
    if (error) {
      return error;
    }
  }
};
